import { TableAction } from './table-action';

export class TableSwitchAction<T> extends TableAction<T> {
  public isActive = false;
  public override category = 'switch';
}
